import React from "react"
import {
	Grid,
	Typography
} from "@material-ui/core"
import { SpeakerNotesOff as SpeakerNotesOffIcon } from "@material-ui/icons"
import useStyles from "@/pages/Attendance/Chat/ChatListPanel/NotificationBar/SlownessNotification/styles"

type SlownessNotificationProps = {
	handleClose: () => void
}

const SlownessNotification: React.FC<SlownessNotificationProps> = (props) => {
	const { handleClose } = props
	const classes = useStyles()

	return (
		<Grid
			container
			alignItems="center"
			justifyContent="center"
			className={classes.slownessNotificationContainer}
		>
			<Grid item>
				<Grid
					container
					className={classes.iconContainer}
					justifyContent="center"
					alignItems="center"
				>
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						className={classes.icon}
					>
						<SpeakerNotesOffIcon />
					</Grid>
				</Grid>
			</Grid>

			<Grid
				item
				className={classes.messageContainer}
			>
				<Typography
					variant="body1"
					className={classes.slownessNotificationContent}
				>
                    Você tem muitos atendimentos em aberto. Isso pode gerar lentidão no inbox. Recomendamos revisar e finalizar os mais antigos que estão sem interação.{" "}
					<Typography
						variant="body1"
						component="span"
						className={classes.actionText}
						onClick={handleClose}
					>
                        Fechar
					</Typography>
				</Typography>
			</Grid>
		</Grid>
	)
}

export default SlownessNotification
